export default {"src":"/_next/static/media/check.9546e3e3.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};